import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faChevronRight } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { SeeAllButton } from '@components/basics/SeeAll';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { GRID_STYLE } from '@utils/constants';

export const AllResultsCarousel = ({
  header,
  slides,
  onClick,
}: {
  header: string;
  slides: {
    id: string;
    slide: React.ReactNode;
  }[];
  onClick: () => void;
}) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h3 className="font-title text-title-l font-medium">{header}</h3>
        <div className="hidden md:block">
          <SeeAllButton onClick={onClick} />
        </div>
        <div className="flex md:hidden">
          <IconButton
            icon={<FontAwesomeIcon icon={faChevronRight} />}
            onClick={onClick}
            size={24}
            iconSize={16}
          />
        </div>
      </div>
      <div className={clsx('gap-2 md:gap-5', GRID_STYLE)}>{slides.map(({ slide }) => slide)}</div>
    </div>
  );
};
